import { useElementSize } from "@/features/useElementSize"
import { Favorite } from "@/features_signal/favorite"
import { PageHeader } from "@/pages/AccountPage/components/PageHeader"
import { GameCardItem } from "@/pages/HomePage/components/GameCardItem"
import { GridGameList } from "@/pages/HomePage/components/GridGameList"
import styled from "@emotion/styled"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

const Root = styled.div`
    width: 100%;
    flex: 1;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;
`

const Content = styled.div`
    flex: 1;
`

const FavoriteGameList = () => {
    const { elementRef, size } = useElementSize<HTMLDivElement>()
    const navigate = useNavigate()

    useEffect(() => {
        Favorite.fetchFav()
    }, [])

    return (
        <Root>
            <PageHeader
                sticky={true}
                title="Favorite"
                iconType="black-arrow"
                textColor="#131416"
                backgroundColor="#fff"
                onBack={() => {
                    navigate(-1)
                }}
            />
            <Content ref={elementRef}>
                <GridGameList<GameApiTypes.Fetcher.Result.GameList>
                    list={Favorite.favList.value}
                    isLoading={Favorite.isLoading.value}
                    height={size?.height ?? 0}
                    itemContent={(index, game) => {
                        return (
                            <GameCardItem
                                {...game}
                                key={`fav_game_item__${index}`}
                            />
                        )
                    }}
                />
            </Content>
        </Root>
    )
}

export { FavoriteGameList }
